import { UserDashboardWidgetModel } from "shared/models";

interface IGroupedWidgets {
    id: string;
    name: string | null;
    widgets: UserDashboardWidgetModel[];
}

export function getGroupedWidgets(content: any): IGroupedWidgets[] {
    if (!content) return [];

    const filteredWidgets =
        content.widgets?.filter(
            (w: UserDashboardWidgetModel) => w.type_id !== "calendar"
        ) || [];

    if (content.groups && content.groups.length > 0) {
        return content.groups.map((group: { id: string; name: string }) => ({
            id: group.id,
            name: group.name,
            widgets:
                filteredWidgets.filter(
                    (w: UserDashboardWidgetModel) => w.group_id === group.id
                ) || [],
        }));
    }
    return [
        {
            id: "all",
            name: null,
            widgets: filteredWidgets || [],
        },
    ];
}
